// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-page-wrapper {
    position: relative;
}
.download-pdf-btn {
    position: absolute;
    top: 24px;
    right: 24px;
    z-index: 10;
    padding: 10px 18px;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    background: #0077d6;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(2,48,84,0.15);
    transition: background 0.15s ease;
}
.download-pdf-btn:hover:not(:disabled) {
    background: #035aa6;
}
.download-pdf-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
@media (max-width: 900px) {
    .download-pdf-btn {
        top: 12px;
        right: 12px;
        padding: 8px 14px;
        font-size: 13px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/download-pdf-button/download-pdf-button.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yCAAyC;IACzC,iCAAiC;AACrC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI;QACI,SAAS;QACT,WAAW;QACX,iBAAiB;QACjB,eAAe;IACnB;AACJ","sourcesContent":[".pdf-page-wrapper {\n    position: relative;\n}\n.download-pdf-btn {\n    position: absolute;\n    top: 24px;\n    right: 24px;\n    z-index: 10;\n    padding: 10px 18px;\n    font-size: 14px;\n    font-weight: 700;\n    color: #fff;\n    background: #0077d6;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    box-shadow: 0 4px 12px rgba(2,48,84,0.15);\n    transition: background 0.15s ease;\n}\n.download-pdf-btn:hover:not(:disabled) {\n    background: #035aa6;\n}\n.download-pdf-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n@media (max-width: 900px) {\n    .download-pdf-btn {\n        top: 12px;\n        right: 12px;\n        padding: 8px 14px;\n        font-size: 13px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
